/**
 * RatingListPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Table,
} from 'components';
import { Button, Input, Select } from 'antd';
import { useNavigate } from 'react-router-dom';

const RatingListPresenter = () => {
  /* ===== ROUTE ===== */
  const navigate = useNavigate();
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const formItem = [
    {
      label: '검색어',
      form: [
        {
          input: (
            <Select
              size="large"
              value={'아이디'}
              options={[
                { label: '아이디', value: '아이디' },
                { label: '회원명', value: '회원명' },
                { label: '전화번호', value: '전화번호' },
              ]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
        {
          input: (
            <Input
              size="large"
              placeholder="검색어를 입력해주세요"
              style={{ ...styles.form.input.large }}
            />
          ),
        },
      ],
    },
    {
      label: '구매금액',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.input.large, marginRight: 0 }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <Input
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.input.large }}
              />
              <p style={{ ...styles.form.text, marginLeft: 8 }}>원</p>
            </>
          ),
        },
      ],
    },
  ];

  // NOTE: 테이블 가짜 데이터
  let newData = [];
  for (let i = 0; i < 5; i++) {
    newData.push({
      등급순위: 1,
      등급명: `Family`,
      사용여부: (
        <Select
          options={[
            { label: '사용', value: 'Y' },
            { label: '미사용', value: 'N' },
          ]}
          size="large"
          style={{ ...styles.form.input.medium }}
        />
      ),
      등급조건: `0원 이상`,
      적립금: '-',
      할인금액: '-',
      추가혜택여부: '-',
    });
  }

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>회원등급 관리</Title>

          {/* 검색필터 */}
          <Content
            maxWidth={'100%'}
            padding={0}
            backgroundColor={'none'}
            style={{ marginBottom: 40 }}
          >
            <ExpandableContainer borderRadius={4} padding={20}>
              {formItem.map((_item, _index) => (
                <div
                  key={`form_${_index}`}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px 0px',
                  }}
                >
                  <div style={{ width: 120, fontSize: 13, fontWeight: 400 }}>
                    <label>{_item.label}</label>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {_item.form.map((_subitem, _subkey) => (
                      <React.Fragment key={`input_${_subkey}`}>
                        {_subitem.input}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              ))}
            </ExpandableContainer>

            {/* 검색/초기화 버튼 */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                marginTop: 20,
              }}
            >
              <Button
                size="large"
                type="primary"
                style={{ ...styles.button, background: 'var(--primary-color)' }}
              >
                검색
              </Button>
              <Button size="large" style={{ ...styles.button }}>
                초기화
              </Button>
            </div>
            {/* 검색/초기화 버튼 끝 */}
          </Content>
          {/* 검색필터 끝 */}

          {/* 검색결과 */}
          <Content maxWidth={'100%'} borderRadius={4} padding={20}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: 20,
              }}
            >
              <h4 style={{ fontSize: 14, fontWeight: 500, marginRight: 20 }}>
                총 <span>0</span>건
              </h4>
              <Button
                size="large"
                style={{ marginRight: 8 }}
                onClick={() => navigate(`register`)}
              >
                등급 추가
              </Button>
              <Button size="large" style={{ marginRight: 8 }}>
                선택 삭제
              </Button>
              <Button size="large" style={{ marginRight: 8 }}>
                등급 자동 변경
              </Button>
            </div>
            <Table
              data={newData}
              isChecked
              columns={[
                {
                  title: '등급순위',
                  key: '등급순위',
                },
                {
                  title: '등급명',
                  key: '등급명',
                },
                {
                  title: '사용여부',
                  key: '사용여부',
                },
                {
                  title: '등급조건',
                  key: '등급조건',
                },
                {
                  title: '적립금',
                  key: '적립금',
                },
                {
                  title: '할인금액',
                  key: '할인금액',
                },
                {
                  title: '추가혜택여부',
                  key: '추가혜택여부',
                },
              ]}
            />
          </Content>
          {/* 검색결과 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default RatingListPresenter;
